import { memo, ReactElement } from 'react'

import isEqual from 'lodash/isEqual'

import { deleteSovKeyword } from 'api/Cerebro/orgScoped/shareOfVoiceApi'
import { userHasSovWritePermissions } from 'helpers/featurePermissions'
import { titleCase } from 'helpers/formatting'
import { usePermissionMessage, useUserHasPermissions } from 'hooks'
import { SovKeyword } from 'types'

import { DeleteField } from '../../SharedFields/DeleteField'

interface Props<RecordType> {
    readOnly: boolean
    record: RecordType
    reloadData: () => void
}

function ArchiveSovKeywordField<RecordType extends SovKeyword>({
    readOnly = false,
    record,
    reloadData,
}: Props<RecordType>): ReactElement {
    const hasPermission = useUserHasPermissions(userHasSovWritePermissions)
    const permissionMessage = usePermissionMessage()

    const getTooltipTitle = (): string | undefined => {
        if (record.user_can_manage) {
            return undefined
        }

        return hasPermission
            ? (record.user_can_manage_detail ?? permissionMessage)
            : permissionMessage
    }

    return (
        <DeleteField
            disabled={!record.user_can_manage || readOnly}
            okText="Archive"
            title="Are you sure you want to archive this keyword?"
            tooltipTitle={getTooltipTitle()}
            updateRequestApi={deleteSovKeyword}
            updateRequestCallback={reloadData}
            updateRequestData={record.id}
            updateRequestSuccessMesg={
                <span>
                    Keyword <strong>{record.text}</strong> for{' '}
                    <strong>{titleCase(record.platform)}</strong> Platform was
                    successfully archived.
                </span>
            }
        />
    )
}

export default memo(
    ArchiveSovKeywordField,
    isEqual
) as typeof ArchiveSovKeywordField
